var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ScheduleWeek - Ctor
    ns.ScheduleWeek = function ScheduleWeek(mStartDate, weekSchedules) {
        this.weekNo = mStartDate.week();
        this.startDate = moment(mStartDate).startOf('week').toDate();
        this.endDate = moment(mStartDate).endOf('week').toDate();

        this.schedules = [];
        if (weekSchedules && weekSchedules.length) {
            this.schedules.push.apply(this.schedules, weekSchedules);
        }
        this.singlePeriodProgramOnly = false;
    }
    // #endregion

    // #region ScheduleWeek - Methods
    ns.ScheduleWeek.prototype.getScheduleByDay = function (dayOfWeek) {
        if (this.schedules) {
            for (var s = 0; s < this.schedules.length; s++) {
                var schedule = this.schedules[s];
                var dateIndicia = schedule.firstPeriodStartDate ||
                                  schedule.firstPeriodEndDate ||
                                  schedule.secondPeriodStartDate ||
                                  schedule.secondPeriodEndDate;

                if (!!dateIndicia) {
                    var scheduleDayOfWeek = moment(dateIndicia).isoWeekday();

                    if (scheduleDayOfWeek === dayOfWeek) {
                        return schedule;
                    }
                }
            }
        }

        return null;
    }

    ns.ScheduleWeek.prototype.removeScheduleByDay = function (dayOfWeek) {
        if (this.schedules) {

            var rindex = -1;

            for (var s = 0; s < this.schedules.length; s++) {
                var schedule = this.schedules[s];
                var dateIndicia = schedule.firstPeriodStartDate ||
                                  schedule.firstPeriodEndDate ||
                                  schedule.secondPeriodStartDate ||
                                  schedule.secondPeriodEndDate;

                if (!!dateIndicia) {
                    var scheduleDayOfWeek = moment(dateIndicia).isoWeekday();

                    if (scheduleDayOfWeek === dayOfWeek) {
                        rindex = s;
                        break;
                    }
                }
            }

            if (rindex !== -1) {
                this.schedules.splice(rindex, 1);
            }
        }
    }

    ns.ScheduleWeek.prototype.getScheduleIndiciesByDay = function (dayOfWeek) {
        var schedule = this.getScheduleByDay(dayOfWeek);
        if (schedule) {
            var am = schedule.firstPeriodStartDate || schedule.firstPeriodEndDate;
            var pm = schedule.secondPeriodStartDate || schedule.secondPeriodEndDate
            if (am && pm) { return 'both'; }
            if (am && this.singlePeriodProgramOnly) { return 'both'; }
            if (am) { return 'am'; }
            if (pm) { return 'pm'; }
        }

        return '';
    }
    //#endregion

    // #region ScheduleWeek - Properties
    Object.defineProperty(ns.ScheduleWeek.prototype, 'monday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(1); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'tuesday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(2); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'wednesday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(3); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'thursday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(4); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'friday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(5); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'saturday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(6); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'sunday', {
        enumerable: true, configurable: true,
        get: function () { return this.getScheduleIndiciesByDay(7); }
    });

    Object.defineProperty(ns.ScheduleWeek.prototype, 'notes', {
        enumerable: true, configurable: true,
        get: function () {

            var days = new Array(7);

            if (this.schedules) {
                for (var s = 0; s < this.schedules.length; s++) {
                    var schedule = this.schedules[s];
                    var dateIndicia = schedule.firstPeriodStartDate ||
                                      schedule.firstPeriodEndDate ||
                                      schedule.secondPeriodStartDate ||
                                      schedule.secondPeriodEndDate;

                    if (!!dateIndicia) {
                        days[moment(dateIndicia).isoWeekday() - 1] = schedule;
                    }
                }
            }

            var result = '';

            for (var d = 0; d < days.length; d++) {
                var day = days[d];
                if (day && !String.prototype.isNullOrWhitespace(day.notes)) {
                    if (String.prototype.isNullOrWhitespace(result)) {
                        result += '{' + d + '}: ' + day.notes;
                    } else {
                        result += ', {' + d + '}: ' + day.notes;
                    }
                }
            }

            return result;
        }
    });
    // #endregion

})(webooker_acivity_models);